export default __webpack_public_path__ + "static/AeonikLight-b4eb9fe80adbe3173d47cbe4e0456d0c.woff2";